<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="info"
    title="FAQ - Как создать пост для рассылки"
    (close)="senderService.isOpenedAddBalance = true"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar" #scroll>
      <div class="text-center">
        <img class="w-100" src="/assets/images/faq/post/faq-post.svg" alt="">
      </div>
    </div>
  </div>
</div>
